import React, { createContext, useContext, useState, useEffect } from 'react';
import { getToken, getTokenExpiration, removeToken } from '../util/jwtToken';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const token = getToken();
    const expiration = getTokenExpiration(token);
    return !!token && !!expiration && new Date() < expiration;
  });

  const [rows, setRows] = useState([]);
  const [originalRows, setOriginalRows] = useState([]);

  useEffect(() => {
    const token = getToken();
    const expiration = getTokenExpiration(token);

    const stillValid = !!token && !!expiration && new Date() < expiration;

    if (!stillValid) {
      removeToken();
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <AppContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        rows,
        setRows,
        originalRows,
        setOriginalRows,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useAppContext = () => useContext(AppContext);
